<app-svg-icon
  [icon]="currentUserStorage.isUserFullImmersion() || this.forceUnlocked
    ? (unfilledLocked ? 'course_unlocked':'course_unlocked_filled')
    : (unfilledLocked ? 'course_locked':'course_locked_filled')"
></app-svg-icon>
